<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="60%">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click="(dialogAdd = false), clearData()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="5" class="text-center">
                        <v-col class="text-center ml-5 mt-16">
                          <v-img
                            :src="require('@/assets/aboutAc.svg')"
                            max-width="300"
                          ></v-img>
                        </v-col>
                      </v-col>

                      <v-col cols="6" class="v-margit_text_add">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.svg')"
                          ></v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 50px">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formAdd.pictureUrlPreview"
                            ></v-img>
                            <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImg"
                              v-model="filesAdd"
                            ></v-file-input>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 35px">
                            <v-subheader id="subtext">หัวข้อ</v-subheader>
                          </v-row>
                          <v-row style="height: 50px">
                            <v-text-field
                              v-model="formAdd.title"
                              placeholder="หัวข้อ"
                              dense
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 35px">
                            <v-subheader id="subtext">ประเภท</v-subheader>
                          </v-row>
                          <v-row style="height: 50px">
                            <v-select
                              v-model="formAdd.type"
                              :items="selectType"
                              dense
                              @change="
                                chkTypeCoin(), chkTypeFiled(), validate('ADD')
                              "
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row
                            style="height: 35px"
                            v-if="formAdd.type !== 'กรอกข้อมูล'"
                          >
                            <v-subheader id="subtext">การทำซ้ำ</v-subheader>
                          </v-row>
                          <v-row style="height: 50px">
                            <v-select
                              v-model="formAdd.repeat"
                              :items="selectRepeat"
                              placeholder="การทำซ้ำ"
                              v-if="formAdd.type !== 'กรอกข้อมูล'"
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                        <v-row class="ml-1 mt-1">
                          <v-col cols="6">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >วันที่เริ่ม</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="formAdd.startDate"
                                    placeholder="วันที่เริ่ม"
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    :rules="[rules.required]"
                                    dense
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="formAdd.startDate"
                                  @input="menu = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-row>
                          </v-col>
                          <v-col>
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >วันที่สิ้นสุด</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="formAdd.endDate"
                                    placeholder="วันที่สิ้นสุด"
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    :rules="[rules.required]"
                                    dense
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="formAdd.endDate"
                                  @input="menu2 = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row class="ml-1 mt-1">
                          <v-col cols="6">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext">จำกัดจำนวน</v-subheader>
                            </v-row>
                            <v-row style="height: 50px">
                              <VuetifyMoney
                                v-model="formAdd.quota"
                                dense
                                required
                                :rules="[rules.required]"
                                v-bind:options="options2"
                              />
                            </v-row>
                          </v-col>
                          <v-col cols="6">
                            <v-row
                              style="height: 35px"
                              v-if="formAdd.type != 'LuckyDraw'"
                            >
                              <v-subheader id="subtext">COIN</v-subheader>
                            </v-row>
                            <v-row style="height: 50px">
                              <VuetifyMoney
                                v-model="formAdd.coin"
                                dense
                                required
                                v-bind:options="options2"
                                v-if="formAdd.type != 'LuckyDraw'"
                              />
                            </v-row>
                          </v-col>
                        </v-row>
                        <div v-if="formAdd.type == 'กรอกข้อมูล'">
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ชื่อ Field1</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-text-field
                                v-model="formAdd.field1Title"
                                placeholder="ชื่อ Field1"
                                dense
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ประเภท Field</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-select
                                v-model="formAdd.field1Type"
                                :items="selectTypeField"
                                placeholder="ประเภท Field"
                                dense
                                :rules="[rules.required]"
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row
                              style="height: 35px"
                              v-if="
                                formAdd.field1Title !== '' &&
                                formAdd.field1Type !== ''
                              "
                            >
                              <v-subheader id="subtext">PRIMARY</v-subheader>
                            </v-row>
                            <v-row style="height: 50px">
                              <v-switch
                                v-model="formAdd.Primary_field"
                                color="primary"
                                placeholder="Primary"
                                v-if="
                                  formAdd.field1Title !== '' &&
                                  formAdd.field1Type !== ''
                                "
                                value="1"
                              ></v-switch>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ชื่อ Field2</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-text-field
                                v-model="formAdd.field2Title"
                                placeholder="ชื่อ Field2"
                                dense
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ประเภท Field</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-select
                                v-model="formAdd.field2Type"
                                :items="selectTypeField"
                                placeholder="ประเภท Field"
                                dense
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row
                              style="height: 35px"
                              v-if="
                                formAdd.field2Title !== '' &&
                                formAdd.field2Type !== ''
                              "
                            >
                              <v-subheader id="subtext">PRIMARY</v-subheader>
                            </v-row>
                            <v-row style="height: 50px">
                              <v-switch
                                v-model="formAdd.Primary_field"
                                color="primary"
                                placeholder="Primary"
                                value="2"
                                v-if="
                                  formAdd.field2Title !== '' &&
                                  formAdd.field2Type !== ''
                                "
                              ></v-switch>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ชื่อ Field3</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-text-field
                                v-model="formAdd.field3Title"
                                placeholder="ชื่อ Field3"
                                dense
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ประเภท Field</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-select
                                v-model="formAdd.field3Type"
                                :items="selectTypeField"
                                placeholder="ประเภท Field"
                                dense
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row
                              style="height: 35px"
                              v-if="
                                formAdd.field3Title !== '' &&
                                formAdd.field3Type !== ''
                              "
                            >
                              <v-subheader id="subtext">PRIMARY</v-subheader>
                            </v-row>
                            <v-row style="height: 50px">
                              <v-switch
                                v-model="formAdd.Primary_field"
                                color="primary"
                                placeholder="Primary"
                                value="3"
                                v-if="
                                  formAdd.field3Title !== '' &&
                                  formAdd.field3Type !== ''
                                "
                              ></v-switch>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ชื่อ Field4</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-text-field
                                v-model="formAdd.field4Title"
                                placeholder="ชื่อ Field4"
                                dense
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row style="height: 35px">
                              <v-subheader id="subtext"
                                >ประเภท Field</v-subheader
                              >
                            </v-row>
                            <v-row style="height: 50px">
                              <v-select
                                v-model="formAdd.field4Type"
                                :items="selectTypeField"
                                placeholder="ประเภท Field"
                                dense
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-row
                              style="height: 35px"
                              v-if="
                                formAdd.field14Title !== '' &&
                                formAdd.field4Type !== ''
                              "
                            >
                              <v-subheader id="subtext">PRIMARY</v-subheader>
                            </v-row>
                            <v-row style="height: 50px">
                              <v-switch
                                v-model="formAdd.Primary_field"
                                color="primary"
                                placeholder="Primary"
                                value="4"
                                v-if="
                                  formAdd.field14Title !== '' &&
                                  formAdd.field4Type !== ''
                                "
                              ></v-switch>
                            </v-row>
                          </v-col>
                        </div>
                        <v-col id="margin">
                          <v-row justify="center">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              :disabled="!validAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->
          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          contain
                          :src="formUpdate.pictureUrlPreview"
                        ></v-img>
                        <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="Image"
                          @change="selectImgUpdate"
                          v-model="filesUpdate"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-text-field
                          v-model="formUpdate.title"
                          label="หัวข้อ"
                          placeholder="หัวข้อ"
                          dense
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  @click="
                    (dialogEdit = false),
                      getDataGlobal(DNS_IP, path, session.data.shopId)
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  :disabled="!validUpdate"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <!-- <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส Exchange Rate*"
                        v-model="formUpdate.id"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.title`]="{ item }">
                    {{ item.title }}
                    <v-chip
                        v-if="new Date().getTime() < new Date(item.endDate).getTime()"
                        class="ma-1"
                        color="green"
                        text-color="white"
                      >
                       <v-icon left >
                        mdi-timer
                      </v-icon>
                        Available
                      </v-chip>
                      <v-chip
                        v-if="new Date().getTime() > new Date(item.endDate).getTime()"
                        class="ma-1"
                        color="red"
                        text-color="white"
                      >
                       <v-icon left class="iconify" data-icon="mdi:timer-remove">
                      </v-icon>
                        Not available
                      </v-chip>
                  </template>
                  <template v-slot:[`item.quota`]="{ item }">
                    {{ formatNumber(item.quota) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          small
                          dark
                          @click.stop="
                            (dialogEdit = true),
                              getDataById(item),
                              validate('UPDATE'),
                              console.log(item)
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab small dark>
                          <report-activity
                            :shopId="item.shopId"
                            :activityId="item.activityId"
                          />
                        </v-btn>
                      </template>
                      <span>สมาชิกที่ร่วมกิจกรรม</span>
                    </v-tooltip>
                     <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" dark fab small color="green">
                      <report-activity-branch-service
                        :shopId="item.shopId"
                        :activityId="item.activityId"
                        :titleActivity="item.title"
                      />
                    </v-btn>
                    </template>
                      <span>สมาชิกที่ร่วมกิจกรรม</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <!-- width="1248" height="624" -->
            <div>
              <member-join />
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
// import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
import reportActivityAVG from '../ReportActivity/ReportActivityAVG.vue'
import reportActivityBS from '../ReportActivity/ReportActivityBS.vue'
import ChartLineAllActivityMemberjoin from '../ReportActivity/CharLineAllActivityMemberjoin'
// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    'report-activity': reportActivityAVG,
    'report-activity-branch-service': reportActivityBS,
    'member-join': ChartLineAllActivityMemberjoin,
    VuetifyMoney,
    QrcodeVue
    // QrcodeStream
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/activity/', // Path Model
      userObj: {
        activityId: '',
        shopId: '',
        title: ''
      },
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Activity',
          disabled: false,
          href: '/Tool/Activity'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      selectTypeField: [
        { text: 'Text', value: 'text' },
        { text: 'Number', value: 'number' },
        { text: 'Datetime', value: 'dateTime' }
      ],
      selectType: [
        { text: 'กรอกข้อมูล', value: 'กรอกข้อมูล' },
        { text: 'Free Coin', value: 'FreeCoin' },
        { text: 'Lucky Draw', value: 'LuckyDraw' }
      ],
      selectRepeat: [
        { text: 'ครั้งเดียว', value: 'OneTime' },
        { text: 'ทุกวัน', value: 'Daily' },
        { text: 'ทุกสัปดาห์', value: 'Weekly' },
        { text: 'ทุกเดือน', value: 'Monthly' }
      ],
      camera: 'auto',
      result: null,
      showScanConfirmation: false,
      // End Menu Config
      dialog: false,
      dataReady: true,
      dataShowQR: false,
      dialogRedeem: false,
      size: 150, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      dialogViewLot: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogSend: false,
      dialogAdd: false,
      dialogAddLot: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogViewAdd: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      filesAdd: null,
      filesUpdate: null,
      formAdd: {
        activityId: '',
        title: '',
        type: '',
        repeat: '',
        startDate: '',
        endDate: '',
        quota: '',
        coin: 0,
        field1Title: '',
        field1Type: '',
        field2Title: '',
        field2Type: '',
        field3Title: '',
        field3Type: '',
        field4Title: '',
        field4Type: '',
        Primary_field: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: ''
      },
      formUpdate: {
        activityId: '',
        title: '',
        type: '',
        repeat: '',
        startDate: '',
        endDate: '',
        quota: '',
        coin: 0,
        field1Title: '',
        field1Type: '',
        field2Title: '',
        field2Type: '',
        field3Title: '',
        field3Type: '',
        field4Title: '',
        field4Type: '',
        Primary_field: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: ''
      },
      formUpdateItem: {
        title: '',
        pictureUrl: ''
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 10 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'กิจกรรม', value: 'title' },
        { text: 'สมาชิก', value: 'TotalMember', align: 'left' },
        { text: 'สมาชิกที่เข้าร่วม', value: 'countMember', align: 'center' },
        { text: 'โควต้าทั้งหมด', value: 'quota', align: 'left' },
        { text: 'โควต้าที่ถูกใช้', value: 'countUse', align: 'left' },
        { text: 'เฉลี่ยโควต้าที่ถูกใช้ (%)', value: 'Percentage', align: 'center' },
        // { text: 'Status', value: 'status' },
        // { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      ProductExchangeRate: [],
      dataItem: [],
      dataItemViewLot: [],
      dataBranch: [],
      dataShopId: [],
      validAdd: true,
      validAddLot: true,
      validUpdate: true,
      dailogViewRedeem: false,
      statusViewRedeem: false
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getDataBranch()
    // this.getProductExchangeRate()
    // console.log(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
    this.dataItem.map((item) => {
      if (item.countUse === 0) {
        item.countMember = item.countUse
      }
      if (item.repeats !== 'OneTime') {
        item.Percentage = item.countMember * 100 / item.quota
      } else if (item.repeats === 'OneTime') {
        item.Percentage = item.countUse * 100 / item.quota
      }
      item.Percentage = `${Number.parseFloat(item.Percentage).toFixed(2)}%`
      item.countMember = `${item.countMember} คน`
      item.countUse = `${item.countUse} ครั้ง`
      item.TotalMember = `${item.TotalMember} คน`
      item.quota = `${item.quota} ครั้ง`
    })
    console.log('dddddd', this.dataItem)
    // this.dataShopId = this.dataItem[0]
    // console.log(this.dataItem)
    // this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId + '&status=waiting')
    // console.log('xxxx', this.dataItem)
  },
  methods: {
    // opendialog () {
    //   this.$refs.modal1.manage()
    // },
    sendData (dt) {
      this.$swal({
        title: 'ต้องการ แจ้งเดือน ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        console.log(dt)
        var data = {
          shopId: dt.shopId,
          module: 'activity',
          referId: dt.activityId,
          pictureUrl: dt.pictureUrl,
          message: dt.title,
          CREATE_USER: this.session.data.userName,
          LAST_USER: this.session.data.userName
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/broadcast/add",
            data
          )
          .then(async (response) => {
            console.log('addDataGlobal DNS_IP + PATH + "add"', response)

            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          })
      })
    },
    appendinstrument () {
      console.log('ddddd22222')
    },
    selectImgUpdate (event) {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg (event) {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    chkTypeCoin () {
      if (this.formAdd.type === 'LuckyDraw') {
        this.formAdd.coin = 0
      }
    },
    chkTypeFiled () {
      if (this.formAdd.type !== 'กรอกข้อมูล') {
        // this.formAdd.coin = 0
        this.formAdd.field1Title = ''
        this.formAdd.field1Type = ''
        this.formAdd.field2Title = ''
        this.formAdd.field2Type = ''
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.Primary_field = ''
      }
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchName
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log('getDataCompany : ', this.dataBranch)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'ADDLOT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_addLot.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search)
    },
    async getDataById (item) {
      console.log(item)
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'activityId',
        item.activityId
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      console.log(this.formUpdate.pictureUrlPreview)
    },
    async addData () {
      this.dataReady = false
      this.dataShowQR = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          const today = new Date()
          // console.log(today)
          const date =
            today.getFullYear() +
            '' +
            (today.getMonth() + 1) +
            '' +
            today.getDate()
          const time =
            today.getHours() +
            '' +
            today.getMinutes() +
            '' +
            today.getSeconds()
          const activityId = 'ACT_' + date + '' + time
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.activityId = activityId
          // this.formAdd.token = tokenKey
          // this.formAdd.statusLot = 'no'
          this.formAdd.shopId = this.$session.getAll().data.shopId
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/activity`, params)
            .then(function (response) {
              _this.formAdd.pictureUrl = _this.DNS_IP + '/' + response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          if (this.formAdd.type === 'กรอกข้อมูล') {
            this.formAdd.repeat = 'OneTime'
          }
          // this.formAdd.qrCodeURL = 'http://localhost:8081/collect?token=' + this.formAdd.token
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false
              // this.dataShowQR = true
              // this.dialogViewAdd = true

              // Load Data
              await this.clearData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          // this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.activityId
          this.formUpdateItem.title = this.formUpdate.title
          this.formUpdateItem.LAST_USER = this.session.data.userName
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/activity`, params)
              .then(function (response) {
                _this.formUpdateItem.pictureUrl =
                  _this.DNS_IP + '/' + response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdateItem.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          // delete this.formUpdate['pictureUrlPreview']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdateItem
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '&status=waiting'
      )
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = 0
      this.formAdd.point = 0
      this.formAdd.status = 'waiting'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = ''
      this.formAdd.lotId = ''
      this.formAdd.countLot = ''
      this.formAdd.branchName = ''
      this.formAdd.lotName = ''
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      // eslint-disable-next-line no-redeclare
      // for (var key in this.search) {
      //   if (this.search[key]) {
      //     this.search[key] = ''
      //   }
      // }
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
.container-linechart {
  widows: 550px;
  height: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/Core/ReportActivityAVG.vue